export const calendarPresentation = {
    data() {
        return {
            maxDayHeight: 0,
            defaultTimeUnit: null, //minutes
            defaultTimeUnitSizeInRems: 3,
            zoom: 1,
            startHour: null, // 9
            finishHour: null, // 17
        };
    },
    computed: {
        profileImage() {
            let defaultImagePath = "";
            switch (this.schduleOwnerProp) {
                case "patient":
                    defaultImagePath = "../../images/patient.jpeg";
                    break;
                case "therapist":
                    defaultImagePath = "../../images/default_therapist.jpeg";
            }
            return _.get(this.scheduleOwner, "profile_photo_url", defaultImagePath);
        },

        dayStyle() {
            const defaultDayHeight =
                (this.defaultTimeUnitSizeInRems * (this.finishHour - this.startHour) * 60) /
                this.defaultTimeUnit;
            return `min-height: ${Math.max(
                defaultDayHeight,
                this.maxDayHeight
            )}rem; z-index: 2; transform:scaleY(${1 / this.zoom})`;
        },
    },
    methods: {
        getMaxDayHeight() {
            this.maxDayHeight = 0;
            const appointmentNodes = document.getElementsByClassName("calendar-entry");
            for (let a of appointmentNodes) {
                const bottom =
                    parseFloat(a.style.top.replace("rem", "")) +
                    parseFloat(a.style.height.replace("rem", "")) +
                    1;
                if (bottom > this.maxDayHeight) this.maxDayHeight = bottom;
            }
        },
        separatorStyle(hour) {
            return {
                left: "3ch",
                top: `calc(${((hour - this.startHour) / (this.defaultTimeUnit / 60)) *
                    this.defaultTimeUnitSizeInRems}rem + 83px)`, // Height of the column headers
                zIndex: 1,
            };
        },

        hourStyle(hour) {
            return {
                right: "2px",
                top: `${((hour - this.startHour) / (this.defaultTimeUnit / 60)) *
                    this.defaultTimeUnitSizeInRems}rem`, //
                zIndex: 1,
            };
        },

        appointmentStyle(appointment) {
            const baseHeight =
                (Math.max(this.defaultTimeUnit, this.getAppointmentDurationInMinutes(appointment)) /
                    this.defaultTimeUnit) *
                this.defaultTimeUnitSizeInRems;
            return {
                top: `${((this.moment(appointment.time_start_at).hour() +
                    this.moment(appointment.time_start_at).minute() / 60 -
                    this.startHour) /
                    (this.defaultTimeUnit / 60)) *
                    this.defaultTimeUnitSizeInRems}rem`, // An appointment's height is 3 rem. Here we decide how many minutes in the current scale this will take
                height: `${baseHeight}rem`,
                minHeight: `${baseHeight}rem`,
                transform: `scaleY(${this.zoom})`,
                zIndex: this.conflicted.includes(appointment.id)
                    ? this.conflicted.indexOf(appointment.id) + 2
                    : 1,
            };
        },

        appointmentClass(appointment) {
            let appointmentClass = appointment.calendar_key || "bg-light";
            if (
                (this.canEditAppointments && this.canEditSpecificAppointment(appointment)) ||
                this.canCompleteAppointment(appointment)
            ) {
                appointmentClass += " cursor-pointer";
            } else {
                appointmentClass += " cursor-not-allowed";
            }
            if (this.conflicted.includes(appointment.id)) {
                appointmentClass += " conflicted";
                if (this.conflicted.indexOf(appointment.id) % 2 > 0) {
                    appointmentClass += " to-right";
                }
            }
            if (this.getAppointmentDurationInMinutes(appointment) < 15) {
                appointmentClass += " short-duration";
            }
            return (appointmentClass += " calendar-appointment");
        },

        resetScale() {
            // By default, days will start at 9AM and end at 5PM and be stretched backwards/forwards as needed.
            this.zoom = 1;
            this.defaultTimeUnit = 15;
            this.startHour = 9;
            this.finishHour = 17;
        },

        setScheduleScale(appointments) {
            let durations = [];
            let maxDuration = 60;
            appointments.forEach(a => {
                let duration = this.getAppointmentDurationInMinutes(a);
                durations.push(duration);
                //maxDuration = Math.min(maxDuration, Math.max((duration % 60) || 60, (duration % 30)) || 60); // maxDuration should be either 15, 30 or 60
                // Uncomment if we want to take fractions longer than the minimum appointment length (or an hour) in consideration
                this.startHour = Math.min(
                    this.startHour,
                    this.moment(a.time_start_at).hour() + this.moment(a.time_start_at).minute() / 60
                ); //pulls the start of the day
                this.finishHour = Math.max(
                    this.finishHour,
                    this.moment(a.time_end_at).hour() + this.moment(a.time_end_at).minute() / 60
                ); // pushes the end of the day
            });
            this.defaultTimeUnit = Math.min(...durations, maxDuration); // If there are 15-minute or 30-minute length appointments, the minimum block size will reflect that.
            if (this.defaultTimeUnit % 15) {
                let rem = this.defaultTimeUnit % 15;
                this.defaultTimeUnit = this.defaultTimeUnit - rem + 15; // Makes the calendar scale a multiple of 15 to avoid setting the scale too large.
            }
            if (this.defaultTimeUnit === 0) {
                //Fix for possible 0-duration appointments entered before validation was fixed
                this.defaultTimeUnit = 15;
            }
        },
    },
};
